import { render, staticRenderFns } from "./Resumen.vue?vue&type=template&id=151d86a7&scoped=true"
import script from "./Resumen.vue?vue&type=script&lang=ts"
export * from "./Resumen.vue?vue&type=script&lang=ts"
import style0 from "./Resumen.vue?vue&type=style&index=0&id=151d86a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151d86a7",
  null
  
)

export default component.exports